import { NetworkHub } from "~/components/admin/network/network-hub";

export const ScreenNetwork = () => <NetworkHub />;
